module.exports = __webpack_public_path__ + "officialStatic/img/news3.16e09e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/news3.png
// module id = X49C
// module chunks = 0